(function () {
  'use strict';

  function init() {
    var header = document.getElementById('site-header');
    if (!header || header.dataset.rmNavigationBound === 'true') return;
    header.dataset.rmNavigationBound = 'true';
    var triggers = Array.prototype.slice.call(header.querySelectorAll('[data-rm-mega-trigger]'));
    var panels = Array.prototype.slice.call(header.querySelectorAll('[data-rm-mega-panel]'));
    var scrim = document.querySelector('[data-rm-mega-scrim]');
    var mobileToggle = header.querySelector('[data-rm-mobile-toggle]');
    var mobileDrawer = header.querySelector('[data-rm-mobile-drawer]');

    function setScrim(open) {
      if (!scrim) return;
      scrim.hidden = !open;
      scrim.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    function closeMega() {
      header.dataset.mega = 'closed';
      triggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
      panels.forEach(function (panel) { panel.hidden = true; panel.dataset.open = 'false'; });
      setScrim(false);
    }

    function openMega(key) {
      if (window.rmShopifyCart && typeof window.rmShopifyCart.close === 'function') window.rmShopifyCart.close();
      closeMobile();
      header.dataset.mega = key;
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', trigger.getAttribute('data-rm-mega-trigger') === key ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var open = panel.getAttribute('data-rm-mega-panel') === key;
        panel.hidden = !open;
        panel.dataset.open = open ? 'true' : 'false';
      });
      setScrim(true);
    }

    function setMobileView(view) {
      if (!mobileDrawer) return;
      mobileDrawer.dataset.mobileView = view || 'root';
      mobileDrawer.querySelectorAll('[data-rm-mobile-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-rm-mobile-panel') !== view;
      });
    }

    function closeMobile() {
      if (!mobileDrawer || !mobileToggle) return;
      mobileDrawer.hidden = true;
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileToggle.setAttribute('aria-label', 'Open menu');
      setMobileView('root');
    }

    function openMobile() {
      if (!mobileDrawer || !mobileToggle) return;
      if (window.rmShopifyCart && typeof window.rmShopifyCart.close === 'function') window.rmShopifyCart.close();
      closeMega();
      setMobileView('root');
      mobileDrawer.hidden = false;
      mobileToggle.setAttribute('aria-expanded', 'true');
      mobileToggle.setAttribute('aria-label', 'Close menu');
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var key = trigger.getAttribute('data-rm-mega-trigger') || '';
        if (header.dataset.mega === key) closeMega();
        else openMega(key);
      });
    });

    if (scrim) scrim.addEventListener('click', closeMega);
    if (mobileToggle && mobileDrawer) {
      mobileToggle.addEventListener('click', function () {
        if (mobileDrawer.hidden) openMobile();
        else closeMobile();
      });
      mobileDrawer.querySelectorAll('[data-rm-mobile-drill]').forEach(function (button) {
        button.addEventListener('click', function () { setMobileView(button.getAttribute('data-rm-mobile-drill') || 'root'); });
      });
      mobileDrawer.querySelectorAll('[data-rm-mobile-back]').forEach(function (button) {
        button.addEventListener('click', function () { setMobileView('root'); });
      });
    }

    document.addEventListener('click', function (event) {
      if (header.dataset.mega === 'closed') return;
      if (!header.contains(event.target)) closeMega();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeMega();
      closeMobile();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024) closeMobile();
      else closeMega();
    }, { passive: true });

    document.addEventListener('rm:cart-open', function () {
      closeMega();
      closeMobile();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
